module.exports = __webpack_public_path__ + "img/ordF3.34e2e50c.jpg";